export type DocumentType = 'cpf' | 'cnpj' | 'rut'

export type ClientType = 'enterprise' | 'society' | 'cooperative' | 'individual'

export type CorporateType = 'matriz' | 'filial'

export type ClientSegment =
  | 'transportation'
  | 'education'
  | 'government'
  | 'retail'
  | 'services'
  | 'trucking'
  | 'construction'
  | 'energy'
  | 'food'
  | 'healthcare'
  | 'tracking'
  | 'other'

export type WizardSteps =
  | 'client'
  | 'address'
  | 'subscription'
  | 'enterprise'
  | 'customization'
  | 'user'

export interface Phone {
  phone: string
  type?: string
  responsible?: string
}

export interface CorporateActivity {
  text: string
  code: string
}

export interface CorporateStructure {
  name: string
  document: string
  document_type: DocumentType
  email: string
  phone: string
  role: string
}

export interface CorporateData {
  corporate_name?: string
  corporate_type?: CorporateType
  share_capital?: string
  legal_nature?: string
  situation?: string
  mien?: string
  main_activity?: CorporateActivity[]
  corporate_structure?: CorporateStructure[]
}

export interface InvoiceConfig {
  software: boolean
  hardware_license: boolean
  hardware_purchase: boolean
  hardware_fines: boolean
  connectivity: boolean
  connectivity_fines: boolean
}

export interface ClientMeta {
  invoice_config?: InvoiceConfig
  [key: string]: any
}

export enum ClientStatus {
  pending = 'pending',
  active = 'active',
  not_renewed = 'not_renewed',
  overdue = 'overdue',
  restricted = 'restricted',
  canceled = 'canceled'
}

export interface Client {
  id: number
  account_name: string
  fantasy_name: string
  description: string
  document: string
  document_type: DocumentType
  email: string
  phones: Phone[]
  type: ClientType
  document_verified: boolean
  billing_cycle_day: number
  country_id?: number
  source?: string
  timezone: string
  picture_id?: number
  corporate_data?: CorporateData
  validated: boolean
  created_at: Date
  updated_at: Date
  deleted_at?: Date
  enterprise_id?: number
  segment: ClientSegment
  wizard: string
  meta?: ClientMeta
  relationships?: Record<string, any>
}
